import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { publique } from '../services/api';
import Coquille, { messagePublic } from './Coquille';

const ETAT = { accorde: ['Accordé', 'pb-tag--oui'], refuse: ['Refusé', 'pb-tag--non'], retire: ['Retiré', 'pb-tag--non'], expire: ['Expiré', 'pb-tag--autre'] };

// Lien de retrait permanent : état courant par société et finalité, puis
// opposition en un geste (tout retirer, toutes sociétés).
export default function Retrait() {
  const { token } = useParams();
  const [r, setR] = useState(null);
  const [erreur, setErreur] = useState('');
  const [fait, setFait] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const charger = () => publique.retrait(token).then((x) => setR(x.data)).catch((e) => setErreur(messagePublic(e)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { charger(); }, [token]);

  const retirer = async () => {
    if (!window.confirm('Retirer tous vos accords ? Nous ne vous contacterons plus pour nos offres.')) return;
    setEnvoi(true); setErreur('');
    try { const nb = r.accordes; await publique.retirer(token); setFait({ nb }); charger(); } catch (e) { setErreur(messagePublic(e)); }
    setEnvoi(false);
  };

  if (erreur && !r) return <Coquille><h1>Lien indisponible</h1><div className="pb-erreur">{erreur}</div></Coquille>;
  if (!r) return <Coquille><p>Chargement…</p></Coquille>;
  return (
    <Coquille>
      <h1>Changer d'avis</h1>
      <p>Vos accords pour <span className="pb-identifiant">{r.identifiant}</span>.</p>
      {fait && <div className="pb-succes">C'est fait : {fait.nb > 1 ? `vos ${fait.nb} accords sont retirés` : 'votre accord est retiré'}. Une preuve horodatée a été créée ; nous ne vous contacterons plus pour nos offres.</div>}
      {erreur && <div className="pb-erreur">{erreur}</div>}
      {r.consentements.length === 0 ? <p>Aucun consentement enregistré pour cet identifiant.</p> : (
        <ul className="pb-recap">
          {r.consentements.map((c, i) => {
            const [lib, cls] = ETAT[c.etat_effectif] || ['—', 'pb-tag--autre'];
            return <li key={i}><span><strong>{c.raison_sociale}</strong><br /><span style={{ fontSize: 13 }}>{c.libelle}</span></span><span className={`pb-tag ${cls}`}>{lib}</span></li>;
          })}
        </ul>
      )}
      {r.accordes > 0 && <button className="pb-btn pb-btn--danger" onClick={retirer} disabled={envoi}>{envoi ? 'Retrait…' : `Retirer mes ${r.accordes > 1 ? r.accordes + ' accords' : 'accord'}`}</button>}
      <p className="pb-note">Le retrait est gratuit, immédiat et sans justification (art. 21 RGPD, art. L34-5 CPCE). Ce lien vous est personnel et reste valable ; conservez-le. Pour un retrait partiel (une seule société ou un seul canal), répondez au message reçu ou contactez la société.</p>
    </Coquille>
  );
}
